import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import Loading from "../common/Loading";
import AppIcons from "../../utils/AppIcons";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import AppSubSections from "../../utils/AppSubSections";
import UserRoles from "../../model/enums/UserRole";
import Client from "../../model/ClientSSO";
import ClientsListElement from "./ClientsSSOListElement";
import ClientsSSOListElement from "./ClientsSSOListElement";

/*
  Component to manage the display of the existing PILOTS list
*/
function ClientsList() {
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // activities information to be displayed
  const [data, setData] = useState<Client[]>([]);
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    apiClient
      ?.get<PagedData<Client[]>>({
        url: APIEndPoints.CLIENTS.ALL,
        requiresToken: false,
      })
      .then((data: PagedData<Client[]>) => {
        setData(data.items);
        //console.log("Clients: ", data.items);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <div className="list-page-header">
        <div className="list-page-title">
          <h1>
            <span>{AppIcons.TOOLS}</span>
            Tools connecting through SSO
          </h1>
        </div>
        <div>
          <Button
            label="Create SSO client"
            purpose={ButtonAction.CREATE}
            onClick={() =>
              navigate(
                SETTINGS.get_path({
                  section: AppSections.CLIENTS,
                  subsection: AppSubSections.CREATE,
                })
              )
            }
          />
        </div>
      </div>
      {data?.length === 0 && (
        <div className="list-no-records">
          No records found. Change search parameters and try again.
        </div>
      )}
      {data?.length > 0 &&
        data.map((item) => {
          // check VIEW rights
          const canView = authManager.getUserRole() === UserRoles.ADMIN;
          return <ClientsSSOListElement data={item} canView={canView} />;
        })}
    </div>
  );
}

export default ClientsList;
